const getDimension = (value, prefix = '', suffix = '') => {
    if (!value)
        return '';
    return prefix + (typeof value === 'number' ? `${value}px` : value) + suffix;
};
const jsToCss = (str) => str.replace(/[A-Z]/g, (letter) => `-${letter.toLowerCase()}`);
const getSpacing = (props) => {
    const dimension = [
        'margin',
        'marginTop',
        'marginRight',
        'marginBottom',
        'marginLeft',
        'padding',
        'paddingTop',
        'paddingRight',
        'paddingBottom',
        'paddingLeft',
    ];
    return dimension.reduce((prev, curr) => {
        if (props[curr]) {
            if (typeof props[curr] === 'string') {
                return `${prev}\n${jsToCss(curr)}: ${props.theme.spacing[props[curr]]};`;
            }
            return `${prev}\n${jsToCss(curr)}: ${props[curr]
                .map((c) => props.theme.spacing[c])
                .join(' ')};`;
        }
        return prev;
    }, '');
};
const getItemSpacing = (props) => {
    return props.itemSpacing
        ? `
    > *:not(:first-of-type) {
      margin-left: ${props.theme.spacing[props.itemSpacing]};
    }
  `
        : '';
};
const replaceColor = (value, colors) => {
    const values = value.split(' ').map((i) => (colors[i] ? colors[i] : i));
    return values.join(' ');
};
const CommonStyles = (props) => `
  border-style: ${props.borderStyle ? props.borderStyle : 'none'};
  border-radius: ${props.borderRadius ? props.theme.borderRadius[props.borderRadius] : '0px'};
  border-width: ${props.borderWeight ? props.theme.borderWeight[props.borderWeight] : '1px'};
  border-color: ${props.borderColor ? props.theme.colors[props.borderColor] : 'unset'};
  ${props.border
    ? `border: ${replaceColor(props.border, props.theme.colors)};`
    : ''}
  ${props.borderTop
    ? `border-top: ${replaceColor(props.borderTop, props.theme.colors)};`
    : ''}
  ${props.borderRight
    ? `border-right: ${replaceColor(props.borderRight, props.theme.colors)};`
    : ''}
  ${props.borderBottom
    ? `border-bottom: ${replaceColor(props.borderBottom, props.theme.colors)};`
    : ''}
  ${props.borderLeft
    ? `border-left: ${replaceColor(props.borderLeft, props.theme.colors)};`
    : ''}
  opacity: ${props.opacity ? props.theme.opacity[props.opacity] : 1};
  box-shadow: ${(p) => p.theme.shadow(p, props.shadow, props.shadowColor)};
  background-color: ${props.backgroundColor
    ? props.theme.colors[props.backgroundColor]
    : 'transparent'};
  ${getDimension(props.width, 'width: ', ';')}
  ${getDimension(props.height, 'height: ', ';')}
  ${getSpacing(props)}
  ${getItemSpacing(props)}
`;

export { CommonStyles };
